"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./FooterSocialIcons.scss");

var _angieslistAppPlatform = require("angieslist-app-platform");

var _icons = require("@angi/icons");

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _TwitterIcon, _FacebookIcon, _PinterestIcon, _YoutubeIcon, _InstagramIcon;

var FooterSocialIcons = function FooterSocialIcons(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("span", {
    style: style,
    className: "footer-social-icons-span"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    id: "footer--social-icons-twitter_v3",
    href: _urlCatalog["default"].social.twitter(),
    title: "Follow us on Twitter",
    target: "_blank",
    rel: "noreferrer",
    "data-track-description": "Twitter"
  }, _TwitterIcon || (_TwitterIcon = /*#__PURE__*/_react["default"].createElement(_icons.TwitterIcon, {
    className: "icon"
  })))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    id: "footer--social-icons-facebook_v3",
    href: _urlCatalog["default"].social.facebook(),
    title: "Follow us on Facebook",
    target: "_blank",
    rel: "noreferrer",
    "data-track-description": "Facebook"
  }, _FacebookIcon || (_FacebookIcon = /*#__PURE__*/_react["default"].createElement(_icons.FacebookIcon, {
    className: "icon"
  })))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    id: "footer--social-icons-pinterest_v3",
    href: _urlCatalog["default"].social.pinterest(),
    title: "Pin us on Pinterest",
    target: "_blank",
    rel: "noreferrer",
    "data-track-description": "Pinterest"
  }, _PinterestIcon || (_PinterestIcon = /*#__PURE__*/_react["default"].createElement(_icons.PinterestIcon, {
    className: "icon"
  })))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    id: "footer--social-icons-youtube_v3",
    href: _urlCatalog["default"].social.youtube(),
    title: "Watch us on Youtube",
    target: "_blank",
    rel: "noreferrer",
    "data-track-description": "YouTube"
  }, _YoutubeIcon || (_YoutubeIcon = /*#__PURE__*/_react["default"].createElement(_icons.YoutubeIcon, {
    className: "icon"
  })))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    id: "footer--social-icons-instagram_v3",
    href: _urlCatalog["default"].social.instagram(),
    title: "Follow us on Instagram",
    target: "_blank",
    rel: "noreferrer",
    "data-track-description": "Instagram"
  }, _InstagramIcon || (_InstagramIcon = /*#__PURE__*/_react["default"].createElement(_icons.InstagramIcon, {
    className: "icon"
  })))));
};

var _default = FooterSocialIcons;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/footer/FooterSocialIcons.js
// module id = 3417
// module chunks = 25